import React from 'react';
import { useTranslation } from 'react-i18next';
import SidebarNav from './SidebarNav'
import CardForm from './CardForm'

const EasyOnBoardingDetailWallet = ({
  values,
  setValues,
  goToNextStep,
  goToPrevStep,
  goToStep,
  skipThisStep,
}) => {
  const { t } = useTranslation();

  return (
    <div className="page__inner page__inner-onboarding">
      <div className="page__container">
        <div className="page__title h3">{t('Subscription details')}</div>

        <div className="page__row">
          <div className="page__col">
            <CardForm
              values={values}
              setValues={setValues}
              goToNextStep={goToNextStep}
              goToPrevStep={goToPrevStep}
              skipThisStep={skipThisStep}
            />
          </div>

          <div className="page__col">
            <SidebarNav goToStep={goToStep} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default EasyOnBoardingDetailWallet;
